/* eslint-disable @typescript-eslint/naming-convention */
export const SET_USER = "@USERS/SET_USER";
export type SET_USER = typeof SET_USER;

export const PURGE_USERS = "@USERS/PURGE_USERS";
export type PURGE_USERS = typeof PURGE_USERS;
